import React from 'react';
import { StarIcon } from 'lucide-react';
const stats = [{
  value: '4.9/5',
  label: 'Valutazione media'
}, {
  value: '+300',
  label: 'Risorse professionali'
}, {
  value: '+2.000',
  label: 'Tecnici'
}, {
  value: '99%',
  label: 'Lo consiglierebbe'
}];
export function ProofStrip() {
  return <section aria-label="Prove sociali" className="border-b border-white/10 bg-ink-900" data-id="element-229" data-mp="2osekih9z3i7f">
      <div className="mx-auto w-full max-w-xl px-4 py-8 sm:py-10 lg:max-w-5xl" data-id="element-230" data-mp="1r4eatwipfdp6">
        <div className="flex items-center justify-center gap-1" aria-hidden="true" data-id="element-231" data-mp="1r29w0jj9oua4">
          {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-accent text-accent" data-id="element-232" data-mp="211scgpzyxxxf" />)}
        </div>
        <p className="mx-auto mt-3 max-w-lg text-center text-[14px] leading-relaxed text-white/65 sm:text-base" data-id="element-233" data-mp="25tiuli55dpze">
          Più di <strong className="font-semibold text-white" data-id="element-234" data-mp="18cldjpwlr6bn">2.000 tecnici</strong> utilizzano già
          il Sistema Tecnico PRO 360™ per organizzare la propria attività e risparmiare ore di
          lavoro amministrativo.
        </p>

        <dl className="mt-7 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4" data-id="element-235" data-mp="3vaegsn7df7db">
          {stats.map(stat => <div key={stat.label} className="rounded-xl border border-white/10 bg-ink-800 px-3 py-4 text-center" data-id="element-236" data-mp="3qbjqz1azkijp">
              <dt className="sr-only" data-id="element-237" data-mp="3hg3yoopvqbg8">{stat.label}</dt>
              <dd data-id="element-238" data-mp="3chsmi7c43ouu">
                <span className="block font-display text-2xl leading-none text-accent sm:text-3xl" data-id="element-239" data-mp="3ci2hk9c0km7e">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-white/45 sm:text-[11px]" data-id="element-240" data-mp="37ksliau4dcal">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}